import { gql } from "@apollo/client";
export const FETCH_ALL_TEAM = gql`
query MyQuery {
  team {
    id
    name
    account {
      name
    }
  }
}
`;
export const UPLOAD_FILE_S3 = gql`
mutation MyMutation($binary: String!, $filename: String!, $foldername: String) {
  upload_image(binary: $binary, filename: $filename, foldername: $foldername) {
    error_code
    error_message
    image_url
    status_code
  }
}
`;
export const GET_ALL_TEAM_ACCOUNT = async (apolloClient: any) => {
  let { data: {team} } = await apolloClient.query({
    query: FETCH_ALL_TEAM,
    variables: {
    }
  });
  //console.log('11111111111',team_contact);
  return team;
}